export default "__VITE_PUBLIC_ASSET__17053930__"